var scope_0 = require('/opt/build/repo/www/vivitravels-en/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a85a85be43e040e579016980fc0b869b.js').default;export default
        Object.assign({}, scope_0 )
    